import { useState, useEffect } from "react";
import PageHeader from "../../pageHeader/pageheader";
import { Card, Form, Space, Table } from "antd";
import { POST } from "../../../utils/apicalls";
import { API } from "../../../config/api";
import moment from "moment";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";
function Designer() {
  const [filterData, setFilterData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const filterEmployee = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        type: "Designer",
        status: true,
      };
      const url = API.FILTER_EMPLOYEE;
      const response: any = await POST(url, obj);
      setFilterData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    filterEmployee(); // Fetch data when the component mounts
  }, []);

  const columns = [
    {
      dataIndex: "type",
      title: "Employee Type",
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
    },
    {
      dataIndex: "email",
      title: "Email",
    },
    {
      dataIndex: "phone",
      title: "Phone",
    },
    {
      dataIndex: "gender",
      title: "Gender",
    },

    {
      dataIndex: "dob",
      title: "Date of Birth",
      render: (dob: any) => (dob ? moment(dob).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "hireDate",
      title: "Hire Date",
      render: (hireDate: any) =>
        hireDate ? moment(hireDate).format("DD/MM/YYYY") : "-",
    },
    {
      dataIndex: "bloodGroup",
      title: "Blood Group",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Admin/Employee/viewuser/${record?.id}`)}
          />
          {/* <Button type="link" onClick={() => handleRowClick(record)}>
            <DownloadOutlined />
          </Button> */}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <PageHeader />

      <div>
        <Container>
          <br />
          <b>Total Designer:-{filterData?.length}</b>
          <Card loading={isLoading}>
            <Table columns={columns} dataSource={filterData} rowKey="id" />
          </Card>
        </Container>
      </div>
    </div>
  );
}

export default Designer;
